<template>
  <div>
    <div v-show="!showDetailPanel" class="key-road">
      <exportDate v-if="showExport" @hideExport="showExport = false" :formData="formData" :tab="tab" :moduleName="moduleName"
                  :moduleType="pRoadType"/>
      <dimension-dialog
          v-if="showExport2"
          @hideExport="showExport2 = false"
          :moduleName="moduleName"
          :params="formData"
          :tab="tab"
          :moduleType="pRoadType"
          :autoChunkMonth="true"
      />
      <div class="header">
        <TitleHeader @on-change-tab="onChangeTab" :tab="tab"/>
        <div class="righth" v-if="pRoadType == 'PROVINCIAL_HIGHWAY'">
          <span style="margin-right:30px;">
            <span class="demonstration">省份</span>
            <el-select v-model="provinceName" placeholder="请选择活动区域" @change="onChangeParams">
              <el-option v-if="areaList.length>1" label="全部" value></el-option>
              <el-option v-for="(item,index) in areaList" :label="item.provinceName" :value="item.provinceName"
                         :key="index"></el-option>
            </el-select>
          </span>
          <span class="demonstration">统计月份</span>
          <el-date-picker
              style="width: 180px;"
              v-model="monTime"
              type="month"
              :clearable="false"
              placeholder="选择月"
              @change="onChangeParams"
              value-format="yyyy-MM"
          ></el-date-picker>
          <el-button v-show="hideExport" style="margin-left:15px;" @click="showExport = true">导出</el-button>
        </div>
      </div>
      <el-form :inline="true" v-if="pRoadType != 'PROVINCIAL_HIGHWAY'&&tab==2">
        <dimension-popover
            ref="objDimensionPopover"
            :isMapValue="true"
            :dimObj="dimObj"
            :change="changeDimension"
            :showBottomButton="false"
            :isItemBindClick="true"
        />
        <el-form-item label="省市区" label-width="75px">
          <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
          <el-cascader
              v-if="areaListPr.length>0"
              :options="areaListPr"
              v-model="formData.provCityCounty"
              :props="propsData()"
              collapse-tags
              filterable
              :before-filter="filterMethod"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="道路编码" label-width="75px">
          <el-input v-model="formData.companyName" clearable placeholder="请输入道路编码"></el-input>
        </el-form-item>
        <template v-if="value1">
          <el-form-item label="站点名称" label-width="75px">
            <el-input v-model="formData.stationName" clearable placeholder="请输入站点名称"></el-input>
          </el-form-item>
          <el-form-item label="吨位区间" label-width="75px">
            <el-select v-model="formData.dunwei" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in dunWeiOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="燃料类型" label-width="75px">
            <el-select v-model="formData.ranliaoType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in ranliaoOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点类型" label-width="75px">
            <el-select v-model="formData.zhanDianType" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点品牌" label-width="75px">
            <el-select v-model="formData.zhanDianBrand" multiple
                       collapse-tags placeholder="请选择">
              <el-option
                  v-for="item in zhanDianBrandOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-button style="margin-left:10px;" class="searchBtn" @click="initData(1,true)">查询</el-button>
        <el-button
            v-show="hideExport"
            style="margin-left:10px;"
            @click="exportData"
        >导出查询结果
        </el-button
        >
        <el-button v-show="hideExport" style="margin-left:10px;" @click="showExport2 = true">导出全部明细</el-button>
        <el-switch
            v-model="value1"
            style="margin-left: 10px"
            active-text="展开"
            inactive-text="收起">
        </el-switch>
      </el-form>
      <el-form :inline="true" v-if="pRoadType != 'PROVINCIAL_HIGHWAY'&&tab!=2">
        <dimension-popover
            ref="objDimensionPopover"
            :isMapValue="true"
            :dimObj="dimObj"
            :change="changeDimension"
            :showBottomButton="false"
            :isItemBindClick="true"
        />
        <el-form-item label="省市区" label-width="75px">
          <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
          <el-cascader
              v-if="areaListPr.length>0"
              :options="areaListPr"
              v-model="formData.provCityCounty"
              :props="propsData()"
              collapse-tags
              filterable
              :before-filter="filterMethod"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="吨位区间" label-width="75px">
          <el-select v-model="formData.dunwei" multiple
                     collapse-tags placeholder="请选择">
            <el-option
                v-for="item in dunWeiOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="燃料类型" label-width="75px">
          <el-select v-model="formData.ranliaoType" multiple
                     collapse-tags placeholder="请选择">
            <el-option
                v-for="item in ranliaoOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="站点类型" v-if="tab === 1" label-width="75px">
          <el-select v-model="formData.zhanDianType" multiple
                     collapse-tags placeholder="请选择">
            <el-option
                v-for="item in zhanDianOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="道路编码" label-width="75px">
          <el-input v-model="formData.companyName" clearable placeholder="请输入道路编码"></el-input>
        </el-form-item>
        <el-button style="margin-left:10px;" class="searchBtn" @click="initData(1,true)">查询</el-button>
        <el-button
            v-show="hideExport"
            style="margin-left:10px;"
            @click="exportData"
        >导出查询结果
        </el-button
        >
        <el-button v-show="hideExport" style="margin-left:10px;" @click="showExport2 = true">导出全部明细</el-button>
      </el-form>
      <main v-if="pRoadType == 'PROVINCIAL_HIGHWAY'">
        <StopTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 0" :index="indexAll"></StopTable>
        <TimeTable @on-to-detail="onToDetail" :allData="allData" v-else :index="indexAll"></TimeTable>
      </main>
      <main v-if="pRoadType != 'PROVINCIAL_HIGHWAY'">
        <operateTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 0" :index="indexAll"></operateTable>
        <flowRateTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 1" :index="indexAll"></flowRateTable>
        <stopNewTable @on-to-detail="onToDetail" :allData="allData" v-if="tab === 2" :index="indexAll"></stopNewTable>
      </main>
      <div class="block" style>
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
    <DescFooter v-show="!showDetailPanel" :tab="tab"/>
    <Detail v-if="showDetailPanel" @on-change-tab="onChangeTab" @on-close="showDetailPanel = false" :pTab="detailTab"
            :pDefaultTime="detailDefaultTime" :pRoadCode="detailRoadCode"/>
  </div>
</template>
<script>
import TitleHeader from './titleHeader.vue' // 头部切换
import StopTable from './stopTable.vue' // 加油站停靠表格
import TimeTable from './timeTable.vue' // 运营时段表格
import flowRateTable from './flowRateTable.vue' // 流量
import operateTable from './operateTable.vue' // 运营
import stopNewTable from './stopNewTable.vue' // 停靠
import DescFooter from './descFooter.vue' // 底部说明
import Detail from '../detail/index.vue'
import nameMixin from './nameMixin'

import http from '@/api/freight.js' //请求汇总
import {hideExport, mergeTree} from '@/utils/tools'
import Util from "utils/util";
import Cookies from "js-cookie";
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import {
  nationaloperateStopDetailExportScreen,
  operateStatisticsExportScreen,
  operateStopDetailExportScreen,
  progress
} from "api/log";
import get from "lodash/get";
import dimensionDialog from "components/exportDate/daphne/dialog.vue";

export default {
  mixins: [nameMixin],
  name: 'key-road',
  components: {
    dimensionDialog,
    StopTable,
    flowRateTable,
    operateTable,
    stopNewTable,
    TimeTable,
    TitleHeader,
    DescFooter,
    Detail,
    dimensionPopover,
  },
  data() {
    var now = new Date()
    now.setMonth(now.getMonth() - 1)

    return {
      dimObj: {
        year: now.getFullYear() + '',
        month: (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : '' + (now.getMonth() + 1)),
        type: '0'
      },
      ranliaoOption: Util.ranLiaoOption,
      dunWeiOption: Util.dunWeiOption,
      zhanDianOption: Util.zhanDianOption,
      zhanDianBrandOption: Util.zhanDianBrandOption,
      value1: true,
      formData: {
        stationName: '',
        provCityCounty: [],
        provCodes: [],
        cityCodes: [],
        countyCodes: [],
        ranliaoType: [],
        zhanDianType: [],
        zhanDianBrand: [],
        companyName:'',
        dunwei:[]
      },
      areaListPr: [],
      hideExport: hideExport,
      showExport: false, //控制批量导出
      showExport2: false, //控制批量导出
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      areaList: [],
      provinceName: '',
      monTime: now,
      total: 0, // 总页数
      allData: [], // 总数据
      index: 1, // 当前页数
      endMonth: '', //请求日期
      pageSize: 20,
      indexAll: 0,

      showDetailPanel: false, // 显示详情面板
      detailTab: 0,
      detailDefaultTime: '',
      detailRoadCode: '',
    }
  },
  created() {
    let type = this.$route.query.type
    this.tab = type ? type : 0
  },
  mounted() {
    if (this.pRoadType =='PROVINCIAL_HIGHWAY'){
      var now = new Date()
      now.setMonth(now.getMonth() - 1)
      let time = now
      let year = time.getFullYear()
      let month = time.getMonth()
      this.endMonth = year + this.initMonth(month)
      this.getProvinces()
      // 同步维度控件
      this.syncDimAndCtrl(year + '', this.initMonth(month))
    }
    this.initData()
    this.getPrInter()
  },
  methods: {
    syncDimAndCtrl(year, month) {
      this.dimObj.year = year
      this.dimObj.month = month
      this.monTime = year + '-' + month
      this.endMonth = year + '' + month
      const pop = this.$refs.objDimensionPopover
      if (pop) {
        if (Array.isArray(pop)) {
          pop.forEach(p => p && p.setCtrlValue && p.setCtrlValue())
        } else if (pop.setCtrlValue) {
          pop.setCtrlValue()
        }
      }
    },
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500)
          }
        })
      }, 200)

      let dateType = get(this, 'dimObj.type', '0')
      if (this.pRoadType != 'PROVINCIAL_HIGHWAY') {
        console.log(this.endMonth)
        const { provCodes, cityCodes, countyCodes } = this.formData

        if (this.tab != 2) {
          if (this.pRoadType == 'HIGHWAY') {
            window.location.assign(
                operateStatisticsExportScreen({
                  reqId,
                  year: this.endMonth.substring(0, 4),
                  month: this.endMonth.substring(4, 6),
                  provCodes: provCodes,
                  cityCodes: cityCodes,
                  countyCodes: countyCodes,
                  dateType,
                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  roadClass: this.formData.daoluType,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2
                })
            )
          }
          if (this.pRoadType == 'NATIONAL_HIGHWAY') {
            // 国道
            window.location.assign(
                nationaloperateStopDetailExportScreen({
                  reqId,
                  year: this.endMonth.substring(0, 4),
                  month: this.endMonth.substring(4, 6),
                  provCodes: provCodes,
                  cityCodes: cityCodes,
                  countyCodes: countyCodes,
                  dateType,
                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  roadClass: this.formData.daoluType,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2
                })
            )
          }
        } else {
          window.location.assign(
              operateStopDetailExportScreen({
                reqId,
                year: this.endMonth.substring(0, 4),
                month: this.endMonth.substring(4, 6),
                provCodes: provCodes,
                cityCodes: cityCodes,
                countyCodes: countyCodes,
                dateType,
                roadcode: this.formData.companyName,
                tonnages: this.formData.dunwei,
                roadClass: this.formData.daoluType,
                fuelTypes: this.formData.ranliaoType,
                stationTypes: this.formData.zhanDianType,
                kinds: this.formData.zhanDianBrand,

                stationName: this.formData.stationName,

                roadType: this.pRoadType == 'HIGHWAY' ? 1 : 2
              })
          )
        }
      }
    },
    propsData() {
      const vm = this
      return {
        lazy: false,
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    filterMethod(value) {
      return http
          .getCountyAreaListBySearch({keyword: value})
          .then(({data}) => {
            if (data.length !== 0) {
              const oldList = this.areaListPr || []
              const newList = data || []
              this.areaListPr = mergeTree(oldList, newList)
              return true // 允许 filter
            }
            return false // 阻止 filter
          })
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaListBySearch({keyword:''})
      this.areaListPr = data
      if (this.areaListPr && this.areaListPr.length == 1 && this.areaListPr[0].value) {
        this.cardNum = Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      }
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getProvinces() {
      http.getProvinces().then((e) => {
        this.areaList = e.data
      })
    },

    initData(num = 0,flag) {
      if(flag){
        this.index=1
        this.indexAll = 0
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let dateType = get(this, 'dimObj.type', '0')
      if (this.pRoadType != 'PROVINCIAL_HIGHWAY') {
        console.log(this.endMonth)
        const { provCodes, cityCodes, countyCodes } = this.formData
        if (this.tab!=2){
          if (this.pRoadType == 'HIGHWAY'){
            http
                .operateStatistics({
                  pageNum: this.index,
                  pageSize: this.pageSize,
                  year: this.endMonth.substring(0, 4),
                  month: this.endMonth.substring(4, 6),
                  provCodes: provCodes,
                  cityCodes: cityCodes,
                  countyCodes: countyCodes,
                  dateType,
                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2
                  // countTime: this.endMonth,
                  // firstIs: num,
                  // provinceName: this.provinceName,
                  // moduleType: this.pRoadType,
                })
                .then((e) => {
                  loading.close();
                  if (e.data && e.data.dataList && e.data.dataList) {
                    this.allData = [...e.data.dataList]
                    this.total = e.data.total
                    this.syncDimAndCtrl(e.data.year+'', e.data.month)
                  } else {
                    this.allData = []
                    this.total = 0
                  }
                })
          }
          if (this.pRoadType == 'NATIONAL_HIGHWAY'){
            http
                .nationalO({
                  pageNum: this.index,
                  pageSize: this.pageSize,
                  year: this.endMonth.substring(0, 4),
                  month: this.endMonth.substring(4, 6),
                  provCodes: provCodes,
                  cityCodes: cityCodes,
                  countyCodes: countyCodes,
                  dateType,
                  roadcode: this.formData.companyName,
                  tonnages: this.formData.dunwei,
                  fuelTypes: this.formData.ranliaoType,

                  stationTypes: this.tab == 1 ? this.formData.zhanDianType : [],
                  sourceType: this.tab == 0 ? 1 : 2,
                  // countTime: this.endMonth,
                  // firstIs: num,
                  // provinceName: this.provinceName,
                  // moduleType: this.pRoadType,
                })
                .then((e) => {
                  loading.close();
                  if (e.data && e.data.dataList && e.data.dataList) {
                    this.allData = [...e.data.dataList]
                    this.total = e.data.total
                    this.syncDimAndCtrl(e.data.year+'', e.data.month)
                  } else {
                    this.allData = []
                    this.total = 0
                  }
                })
          }
        }else{
          http
              .operateStopDetail({
                pageNum: this.index,
                pageSize: this.pageSize,
                year: this.endMonth.substring(0, 4),
                month: this.endMonth.substring(4, 6),
                provCodes: provCodes,
                cityCodes: cityCodes,
                countyCodes: countyCodes,
                dateType,
                roadcode: this.formData.companyName,
                tonnages: this.formData.dunwei,
                fuelTypes: this.formData.ranliaoType,
                stationTypes: this.formData.zhanDianType,
                kinds: this.formData.zhanDianBrand,
                stationName: this.formData.stationName,

                roadType:this.pRoadType == 'HIGHWAY'?1:2

                // countTime: this.endMonth,
                // firstIs: num,
                // provinceName: this.provinceName,
                // moduleType: this.pRoadType,
              })
              .then((e) => {
                loading.close();
                if (e.data && e.data.dataList && e.data.dataList) {
                  this.allData = e.data.dataList.map(item=>{
                    item.stationTypeName = this.zhanDianOption.filter(item2=>item.stationType==item2.value)[0].label
                    return item
                  })
                  this.total = e.data.total
                  this.syncDimAndCtrl(e.data.year+'', e.data.month)
                } else {
                  this.allData = []
                  this.total = 0
                }
              })
        }

      } else {
        http
            .carOperate({
              page: this.index,
              pageSize: this.pageSize,
              countTime: this.endMonth,
              firstIs: num,
              provinceName: this.provinceName,
              moduleType: this.pRoadType,
            })
            .then((e) => {
              loading.close();
              if (e.data && e.data.tPageUtil && e.data.tPageUtil.list) {
                this.allData = [...e.data.tPageUtil.list]
                this.total = e.data.tPageUtil.count
                this.monTime = e.data.time
                let time = e.data.time
                this.endMonth = time.replace('-', '')
              } else {
                this.allData = []
                this.total = 0
              }
            })
      }
    },

    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },

    onToDetail(roadCode) {
      this.showDetailPanel = true
      this.detailTab = this.tab
      this.detailDefaultTime = this.endMonth
      this.detailRoadCode = roadCode
    },

    onChangeTab(tabIndex) {
      this.tab = tabIndex
      this.allData=[]
      this.endMonth=''
      this.indexAll = 0
      // var now = new Date()
      // now.setMonth(now.getMonth() - 1)
      // let time = now
      // let year = time.getFullYear()
      // let month = time.getMonth()
      // this.monTime=now
      // this.endMonth = year + this.initMonth(month)
      this.index=1
      console.log('123123')
      this.dimObj.type='0'
      if (this.pRoadType =='PROVINCIAL_HIGHWAY'){
        var now = new Date()
        now.setMonth(now.getMonth() - 1)
        let time = now
        let year = time.getFullYear()
        let month = time.getMonth()
        this.endMonth = year + this.initMonth(month)
        this.syncDimAndCtrl(year+'', this.initMonth(month))
        this.provinceName = ''
      }
      this.formData = {
        provCityCounty: [],
        provCodes: [],
        cityCodes: [],
        countyCodes: [],
        ranliaoType: [],
        zhanDianType: [],
        zhanDianBrand: [],
        companyName:'',
        dunwei:[]
      }
      this.initData()
    },

    changeDimension(e) {
      if (e && e.isOk) {
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = e.type
        this.monTime = e.year + '-' + e.month
        this.endMonth = e.year + '' + e.month
      }
    },

    onChangeParams() {
      let time = this.monTime
      let arr = time.split('-')
      this.index = 1
      this.indexAll = 0
      this.endMonth = arr[0] + '' + arr[1]
      this.syncDimAndCtrl(arr[0]+'', arr[1])

      if (this.pRoadType =='PROVINCIAL_HIGHWAY'){
        this.initData()
      }
    },

    onChangePage(index) {
      this.index = index
      this.initData(1)
      this.indexAll = this.pageSize * (index - 1)
    },
  },
  watch: {
    'formData.provCityCounty': {
      handler(val) {
        let provCodes = []
        let cityCodes = []
        let countyCodes = []
        if (Array.isArray(val) && val.length > 0) {
          val.forEach(item => {
            if (item && item.length > 0) {
              if (item.length === 1) {
                provCodes.push(item[0])
              } else if (item.length === 2) {
                cityCodes.push(item[1])
              } else if (item.length === 3) {
                countyCodes.push(item[2])
              }
            }
          })
        }
        this.formData.provCodes = provCodes
        this.formData.cityCodes = cityCodes
        this.formData.countyCodes = countyCodes
      },
      deep: true
    }
  }
}
</script>

<style lang='stylus' scoped>
.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: #336db0;

  &::after {
    background: #336db0;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.key-road {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}

.block {
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>
